//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum ButtonSize {
	XSmall = "xSmall",
	ResponsiveFromXSmallToSmall = "responsiveFromXSmallToSmall",
	Small = "small",
	ResponsiveFromSmallToMedium = "responsiveFromSmallToMedium",
	ResponsiveFromSmallToLarge = "responsiveFromSmallToLarge",
	ResponsiveFromMediumToSmall = "responsiveFromMediumToSmall",
	Medium = "medium",
	ResponsiveFromMediumToLarge = "responsiveFromMediumToLarge",
	ResponsiveFromLargeToSmall = "responsiveFromLargeToSmall",
	Large = "large",
	ResponsiveFromLargeToXLarge = "responsiveFromLargeToXLarge",
	XLarge = "xLarge"
}
